import { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { personalAPI } from '../services/api';
import { EditableInput } from '../utils/adminShared';

const PersonalPanel = () => {
    const [loading, setLoading] = useState(true);
    const [personal, setPersonal] = useState([]);
    const [nuevoPersonal, setNuevoPersonal] = useState({ nombre: '', cargo: '', costo_hora: 0 });

    useEffect(() => {
        cargarDatos();
    }, []);

    const cargarDatos = async () => {
        setLoading(true);
        try {
            const res = await personalAPI.getAll(true);
            setPersonal(res.data || []);
        } catch (err) {
            console.error('Error al cargar personal:', err);
        } finally {
            setLoading(false);
        }
    };

    const agregarPersonal = async () => {
        if (!nuevoPersonal.nombre.trim()) {
            toast.error('El nombre es obligatorio');
            return;
        }
        try {
            await personalAPI.create(nuevoPersonal);
            setNuevoPersonal({ nombre: '', cargo: '', costo_hora: 0 });
            cargarDatos();
        } catch (err) {
            toast.error('Error: ' + err.message);
        }
    };

    const actualizarPersonal = async (id, data) => {
        try {
            await personalAPI.update(id, data);
            setPersonal(prev => prev.map(p => p.id === id ? { ...p, ...data } : p));
        } catch (err) {
            toast.error('Error: ' + err.message);
            cargarDatos();
        }
    };

    const eliminarPersonal = (id, nombre) => {
        toast((t) => (
            <div className="toast-confirm">
                <p>¿Eliminar a <strong>{nombre}</strong>?</p>
                <div className="toast-confirm-buttons">
                    <button className="toast-btn toast-btn-cancel" onClick={() => toast.dismiss(t.id)}>
                        Cancelar
                    </button>
                    <button
                        className="toast-btn toast-btn-danger"
                        onClick={async () => {
                            toast.dismiss(t.id);
                            try {
                                await personalAPI.delete(id);
                                toast.success('Personal eliminado');
                                cargarDatos();
                            } catch (err) {
                                toast.error('Error: ' + err.message);
                            }
                        }}
                    >
                        Eliminar
                    </button>
                </div>
            </div>
        ), { duration: Infinity });
    };

    if (loading) {
        return <div className="loading">Cargando personal...</div>;
    }

    return (
        <div className="card">
            <div className="card-header">
                <h2>Personal</h2>
            </div>
            <div className="admin-content">
                <h3 className="h3">Agregar Personal</h3>
                <div className="form-row">
                    <label className="field">
                        <span className="label">Nombre *</span>
                        <input
                            className="input"
                            type="text"
                            value={nuevoPersonal.nombre}
                            onChange={(e) => setNuevoPersonal(n => ({ ...n, nombre: e.target.value }))}
                        />
                    </label>
                    <label className="field">
                        <span className="label">Cargo</span>
                        <input
                            className="input"
                            type="text"
                            value={nuevoPersonal.cargo}
                            onChange={(e) => setNuevoPersonal(n => ({ ...n, cargo: e.target.value }))}
                        />
                    </label>
                    <label className="field">
                        <span className="label">Costo/hora</span>
                        <input
                            className="input"
                            type="number"
                            min="0"
                            step="0.01"
                            value={nuevoPersonal.costo_hora}
                            onChange={(e) => setNuevoPersonal(n => ({ ...n, costo_hora: parseFloat(e.target.value) || 0 }))}
                        />
                    </label>
                    <button className="btn neon" type="button" onClick={agregarPersonal}>
                        + Agregar
                    </button>
                </div>

                <div className="divider" />

                <h3 className="h3">Personal Existente</h3>
                <div className="admin-list">
                    {personal.map(p => (
                        <div key={p.id} className={`admin-item ${!p.activo ? 'inactive' : ''}`}>
                            <div className="admin-item-content">
                                <EditableInput
                                    type="text"
                                    value={p.nombre}
                                    onSave={(val) => actualizarPersonal(p.id, { nombre: val })}
                                />
                                <EditableInput
                                    type="text"
                                    value={p.cargo || ''}
                                    onSave={(val) => actualizarPersonal(p.id, { cargo: val })}
                                    placeholder="Cargo..."
                                />
                                <div className="field-inline">
                                    <span className="label">$/hr:</span>
                                    <EditableInput
                                        className="input small"
                                        type="number"
                                        min="0"
                                        step="0.01"
                                        value={p.costo_hora}
                                        onSave={(val) => actualizarPersonal(p.id, { costo_hora: val })}
                                    />
                                </div>
                            </div>
                            <div className="admin-item-actions">
                                <button
                                    className={`btn ghost small ${p.activo ? '' : 'success'}`}
                                    onClick={() => actualizarPersonal(p.id, { activo: !p.activo })}
                                >
                                    {p.activo ? 'Desactivar' : 'Activar'}
                                </button>
                                <button
                                    className="btn ghost small danger"
                                    onClick={() => eliminarPersonal(p.id, p.nombre)}
                                >
                                    Eliminar
                                </button>
                            </div>
                        </div>
                    ))}
                    {personal.length === 0 && (
                        <p className="empty-message">No hay personal creado</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PersonalPanel;
